"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  themeObject: true,
  themeConstants: true
};
exports.themeObject = exports.themeConstants = exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var components = _interopRequireWildcard(require("./components"));
var _palette = _interopRequireDefault(require("./palette"));
var _shadows = _interopRequireWildcard(require("./shadows"));
Object.keys(_shadows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shadows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shadows[key];
    }
  });
});
var _shape = _interopRequireDefault(require("./shape"));
var _spacing = _interopRequireDefault(require("./spacing"));
var _typography = _interopRequireDefault(require("./typography"));
var _themeConstants = _interopRequireWildcard(require("./constants"));
exports.themeConstants = _themeConstants;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const themeObject = exports.themeObject = {};
themeObject.shape = _shape.default;
themeObject.breakpoints = _breakpoints.default;
themeObject.components = components;
themeObject.palette = _palette.default;
themeObject.shadows = _shadows.default;
themeObject.spacing = _spacing.default;
themeObject.typography = _typography.default;
const theme = (0, _material.createTheme)(themeObject);
var _default = exports.default = theme;
//# sourceMappingURL=index.js.map